import { motion, useAnimation } from "framer-motion";
import { useEffect, useRef } from "react";
import { PROJECTS } from "@/lib/data";
import { MANIFESTO } from "@/constants/testIds";

const EASE = [0.76, 0, 0.24, 1];

const RevealHeading = ({ children, className = "" }) => {
  const controls = useAnimation();
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            controls.start({ y: "0%" });
            io.disconnect();
          }
        });
      },
      { threshold: 0.05 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [controls]);
  return (
    <span className="line-mask" ref={ref}>
      <motion.span
        initial={{ y: "110%" }}
        animate={controls}
        transition={{ duration: 1.0, ease: EASE }}
        className={className}
      >
        {children}
      </motion.span>
    </span>
  );
};

export default function Manifesto() {
  return (
    <section
      id="approach"
      data-testid={MANIFESTO.root}
      className="relative bg-[#0a0a0b] text-white"
    >
      {/* Section header */}
      <div className="px-6 md:px-10 pt-32 md:pt-48 pb-16 md:pb-24">
        {/* Transition cue into the stacked project slides below */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 1.0, ease: EASE, delay: 0.2 }}
          className="mt-24 md:mt-40 flex items-end justify-between gap-8"
        >
          <div>
            <h3 className="font-display !normal-case text-[10vw] md:text-[6vw] lg:text-[5vw] leading-[0.94] tracking-[-0.02em]">
              Selected Projects
            </h3>
          </div>
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
            className="mono-label text-white/60 flex flex-col items-center gap-2 shrink-0 pb-4"
            aria-hidden="true"
          >
            <span>Scroll</span>
            <span className="text-lg leading-none">↓</span>
          </motion.div>
        </motion.div>
      </div>

      <div className="hairline" />

      {/* Studio stats moved to dedicated Studio section */}
    </section>
  );
}

// Re-export project list for other components that want to keep a single import path
export { PROJECTS };
